import { memoize } from 'lodash'

const SuiteOrderingPreferenceViewModel = memoize((preference) => {
  return {
    general: {
      showHeader: false,
      host: preference.host,
      receiptEmail: preference.receiptEmail
    },
    flags: {
      showHeader: false,
      lockRefrigerator: preference.lockRefrigerator === "Open",
      lockLiquorCabinet: preference.lockLiquorCabinet === "Open",
      presentBill: preference.presentBill === "Yes",
      provideReceipt: preference.provideReceipt === "Yes",
      discountDescription: preference.discountDescription,
    },
    entitlements: {
      showHeader: true,
      taxExempt: preference.taxExempt === "Yes",
    },
    preorder: {
      showHeader: true,
      payments: preference.preorder.payments.map(payment => {
        return {
          uuid: payment.uuid,
          paymentType: payment.paymentType,
          authorizedSignatory: payment.authorizedSignatory,
          externalRefId: payment.externalRefId,
          shortDescription: payment.shortDescription,
        }
      }),
      gratuity: {
        gratuity: preference.preorder.gratuity,
        gratuityIsPercentage: preference.preorder.gratuityIsPercentage,
        gratuityIsAdjustable: preference.preorder.gratuityIsAdjustable,
        maxGratuity: preference.preorder.maxGratuity,
        maxGratuityDisplay: preference.preorder.maxGratuityDisplay
      }
    },
    day_of_event: {
      showHeader: true,
      payments: preference.day_of_event.payments.map(payment => {
        return {
          uuid: payment.uuid,
          paymentType: payment.paymentType,
          authorizedSignatory: payment.authorizedSignatory,
          externalRefId: payment.externalRefId,
          shortDescription: payment.shortDescription,
        }
      }),
      gratuity: {
        gratuity: preference.day_of_event.gratuity,
        gratuityIsPercentage: preference.day_of_event.gratuityIsPercentage,
        gratuityIsAdjustable: preference.day_of_event.gratuityIsAdjustable,
        maxGratuity: preference.day_of_event.maxGratuity,
        maxGratuityDisplay: preference.day_of_event.maxGratuityDisplay
      }
    },
    coffee: {
      showHeader: true,
      payments: preference.coffee.payments.map(payment => {
        return {
          uuid: payment.uuid,
          paymentType: payment.paymentType,
          authorizedSignatory: payment.authorizedSignatory,
          externalRefId: payment.externalRefId,
          shortDescription: payment.shortDescription,
        }
      }),
      gratuity: {
        gratuity: preference.coffee.gratuity,
        gratuityIsPercentage: preference.coffee.gratuityIsPercentage,
        gratuityIsAdjustable: preference.coffee.gratuityIsAdjustable,
        maxGratuity: preference.coffee.maxGratuity,
        maxGratuityDisplay: preference.coffee.maxGratuityDisplay
      },
      shouldVisit: preference.coffee.shouldVisit,
    },
    cordial: {
      showHeader: true,
      payments: preference.cordial.payments.map(payment => {
        return {
          uuid: payment.uuid,
          paymentType: payment.paymentType,
          authorizedSignatory: payment.authorizedSignatory,
          externalRefId: payment.externalRefId,
          shortDescription: payment.shortDescription,
        }
      }),
      gratuity: {
        gratuity: preference.cordial.gratuity,
        gratuityIsPercentage: preference.cordial.gratuityIsPercentage,
        gratuityIsAdjustable: preference.cordial.gratuityIsAdjustable,
        maxGratuity: preference.cordial.maxGratuity,
        maxGratuityDisplay: preference.cordial.maxGratuityDisplay
      },
      shouldVisit: preference.cordial.shouldVisit,
    },
    dessert: {
      showHeader: true,
      payments: preference.dessert.payments.map(payment => {
        return {
          uuid: payment.uuid,
          paymentType: payment.paymentType,
          authorizedSignatory: payment.authorizedSignatory,
          externalRefId: payment.externalRefId,
          shortDescription: payment.shortDescription,
        }
      }),
      gratuity: {
        gratuity: preference.dessert.gratuity,
        gratuityIsPercentage: preference.dessert.gratuityIsPercentage,
        gratuityIsAdjustable: preference.dessert.gratuityIsAdjustable,
        maxGratuity: preference.dessert.maxGratuity,
        maxGratuityDisplay: preference.dessert.maxGratuityDisplay
      },
      shouldVisit: preference.dessert.shouldVisit,
    },
    restock: {
      showHeader: true,
      payments: preference.restock.payments.map(payment => {
        return {
          uuid: payment.uuid,
          paymentType: payment.paymentType,
          authorizedSignatory: payment.authorizedSignatory,
          externalRefId: payment.externalRefId,
          shortDescription: payment.shortDescription,
        }
      }),
      gratuity: {
        gratuity: preference.restock.gratuity,
        gratuityIsPercentage: preference.restock.gratuityIsPercentage,
        gratuityIsAdjustable: preference.restock.gratuityIsAdjustable,
        maxGratuity: preference.restock.maxGratuity,
        maxGratuityDisplay: preference.restock.maxGratuityDisplay
      }
    },
    customer_notes: {
      showHeader: true,
      notes: preference.notes
    },
    pos_notes: {
      showHeader: false,
      notes: preference.posNotes || ''
    }
  }
})

export default SuiteOrderingPreferenceViewModel
